/**
 * Collection Header - Filter Navigation
 * Handles filter button clicks and dynamic visibility based on available products
 */

class CollectionFilter {
  constructor() {
    this.filterButtonsContainer = document.querySelector('.collection-header__links [data-filter-value]')?.parentElement;
    this.init();
  }

  init() {
    if (!this.filterButtonsContainer) return;

    // Set up click handlers
    const filterButtons = this.filterButtonsContainer.querySelectorAll('[data-filter-value]');
    filterButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.applyFilter(button.dataset.filterValue);
      });
    });

    // Check visibility on load
    this.updateButtonVisibility();

    // Re-check visibility when filters update (page reload handles this naturally)
    // But also watch for any dynamic filter updates
    this.observeFilterChanges();
  }

  updateButtonVisibility() {
    const genderCounts = this.getGenderFilterCounts();

    // Only show buttons if BOTH Mens AND Womens have products available
    const shouldShow = genderCounts.mens > 0 && genderCounts.womens > 0;

    if (shouldShow) {
      this.filterButtonsContainer.style.display = '';
    } else {
      this.filterButtonsContainer.style.display = 'none';
    }
  }

  getGenderFilterCounts() {
    const counts = {
      mens: 0,
      womens: 0,
      unisex: 0
    };

    // Find the gender filter in the facets
    const genderFilter = document.querySelector('[id*="filter.p.m.custom.shopify_gender"]');
    if (!genderFilter) return counts;

    // Find all filter value inputs
    const filterInputs = genderFilter.querySelectorAll('input[name="filter.p.m.custom.shopify_gender"]');

    filterInputs.forEach(input => {
      const value = input.value;
      const label = input.closest('label, .facets__label');

      if (!label) return;

      // Extract count from the label text (e.g., "Mens (25 products)" or "(25)")
      const labelText = label.textContent;
      const countMatch = labelText.match(/\((\d+)/);
      const count = countMatch ? parseInt(countMatch[1], 10) : 0;

      if (value === 'Mens') {
        counts.mens = count;
      } else if (value === 'Womens') {
        counts.womens = count;
      } else if (value === 'Unisex') {
        counts.unisex = count;
      }
    });

    return counts;
  }

  observeFilterChanges() {
    // Watch for changes to the facets container
    const facetsContainer = document.querySelector('.facets-container, #FacetsWrapperDesktop, #FacetsWrapperMobile');
    if (!facetsContainer) return;

    const observer = new MutationObserver(() => {
      this.updateButtonVisibility();
    });

    observer.observe(facetsContainer, {
      childList: true,
      subtree: true
    });
  }

  applyFilter(filterValue) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // Remove all existing gender filter parameters
    params.delete('filter.p.m.custom.shopify_gender');

    // Add the new filter
    params.append('filter.p.m.custom.shopify_gender', filterValue);

    // Navigate to the new URL
    window.location.href = url.toString();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionFilter();
  });
} else {
  new CollectionFilter();
}
